import React from "react";
import PropTypes from "prop-types";
import propTypes from "@styled-system/prop-types";
import { BadgeStyle } from "./badge.style";

const Badge = ({
  innerRef,
  ...attributes
}) => {
  return (
    <BadgeStyle {...attributes} ref={innerRef} />
  );
};

Badge.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  colors: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "danger",
    "primaryWithBg",
    "secondaryWithBg",
    "infoWithBg",
    "successWithBg",
    "warningWithBg",
    "dangerWithBg",
  ]),
  variant: PropTypes.oneOf(["", "pill"]),
  ...propTypes.space,
  ...propTypes.typography,
};

export default Badge;
